import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

export const EditIcon = styled(FontAwesomeIcon)<{ isDisabled?: boolean }>`
  color: ${({ theme: { palette }, isDisabled }) =>
    isDisabled ? palette.primary_200 : palette.primary};
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  font-size: 16px;
  margin-left: 8px;
  margin-top: -1px;
  transition: all 0.2s ease;
  color: ${({ theme: { palette } }) => palette.primary};
  &:active {
    transform: scale(0.8);
    opacity: 0;
  }
  &:hover {
    color: ${({ theme: { palette } }) => palette.primary_600};
    transform: scale(1.1);
  }
`
